import { render, staticRenderFns } from "./card-producto.vue?vue&type=template&id=156ce4f6&scoped=true"
import script from "./card-producto.vue?vue&type=script&lang=js"
export * from "./card-producto.vue?vue&type=script&lang=js"
import style0 from "./card-producto.vue?vue&type=style&index=0&id=156ce4f6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156ce4f6",
  null
  
)

export default component.exports